import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SearchIcon from '@mui/icons-material/Search';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

import i18n from 'FRONTEND/utils/i18n';

export const getMultipleExpertStepSupport = () => {
  return {
    title: i18n._('How to find practitioners?'),
    text: i18n._('You are able to invite any user to the appointment. Those who did not delegate their calendar management to you in their profile settings will have to approve the appointments.'),
    paragraphList: [
      {
        title: i18n._('Type at least three letters to search'),
        text: i18n._('In order for the search to give results, you need to supply at least three consecutive characters contained in the practitioner’s name.'),
        icon: SearchIcon,
      },
      {
        title: i18n._('Be more specific to narrow down the search'),
        text: i18n._('Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching practitioners and find the ones you are looking for.'),
        icon: ZoomInIcon,
      },
      {
        title: i18n._('Make sure some practitioners are available'),
        text: i18n._('Only the practitioners who are available for the appointment type you have chosen are listed here. If they delegated their calendar to you, you are able to edit their availabilities.'),
        icon: EventAvailableIcon,
      },
    ],
  };
};
